module.exports = __webpack_public_path__ + "img/1466674215.58318a06.jpg";